import { track } from '@vercel/analytics'
import router from '@/router'

type AllowedValue = string | number | boolean | null

const VERSION = `${__APP_VERSION__}-${__GIT_SHA__.slice(0, 7)}`

const seenErrors = new Set<string>()

function truncate(value: string, max = 256): string {
  return value.length > max ? value.slice(0, max - 1) + '…' : value
}

function currentRouteName(): string {
  const name = router.currentRoute.value.name
  return typeof name === 'string' ? name : 'unknown'
}

export function trackEvent(
  name: string,
  props: Record<string, AllowedValue> = {}
): void {
  const payload: Record<string, AllowedValue> = { version: VERSION }
  for (const [key, value] of Object.entries(props)) {
    if (value == null) continue
    payload[key] = typeof value === 'string' ? truncate(value) : value
  }
  track(name, payload)
}

export function trackAppLoaded(): void {
  if (sessionStorage.getItem('__app_loaded_tracked__')) return
  sessionStorage.setItem('__app_loaded_tracked__', '1')
  const pwa = window.matchMedia('(display-mode: standalone)').matches
  trackEvent('app_loaded', { pwa })
}

export function trackError(message: string, source: 'vue' | 'promise'): void {
  const route = currentRouteName()
  const fingerprint = `${source}|${route}|${message}`
  if (seenErrors.has(fingerprint)) return
  seenErrors.add(fingerprint)
  trackEvent('client_error', { message, source, route })
}
